export enum OFFER_PERMISSIONS {
  OFFER_VIEW = 'OFFER_ORDERVIEW',
  OFFER_WRITE = 'OFFER_ORDERWRITE',
}
